import locacoes from "@/services/locacoes";
import alerts from "@/mixins/alerts.js";

export default {
  mixins: [alerts],

  data() {
    return {
      cadastrandoOrdem: false
    };
  },

  methods: {
    async cadastrarOrdemTransporte(formulario) {
      this.cadastrandoOrdem = true;

      try {
        const ordem = await locacoes.ordens_transporte.cadastrar(formulario);

        this.$router.push({
          name: "locacoes-ordens-transporte",
          params: {
            codigo: ordem.id
          }
        });
      } catch (error) {
        this.error(error.response.data.message);
      } finally {
        this.cadastrandoOrdem = false;
      }
    }
  }
};
